import _toConsumableArray from '../../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js';
import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default, { useState, useEffect } from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles, ExpansionPanel, ExpansionPanelSummary, Typography, ExpansionPanelDetails, Grid } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import clsx from 'clsx';
import CustomRichText from '../../common/CustomRichText.js';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { retrieveContentfulImage } from '../../common/image.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    expansionSkele: {
      width: "100%",
      margin: theme.spacing(0, 2)
    },
    expansionPanel: {
      width: "100%",
      backgroundColor: "#F8F8F3",
      boxShadow: "unset",
      marginBottom: theme.spacing(5),
      "&::before": {
        backgroundColor: "unset"
      },
      "&:last-child": {
        marginBottom: 0
      },
      "&.Mui-expanded": {
        margin: 0
      },
      "& .MuiIconButton-root": {
        color: theme.palette.text.white,
        padding: theme.spacing(0, 1.5),
        "&:hover": {
          backgroundColor: "unset"
        }
      }
    },
    expansionPanelSummary: {
      minHeight: "unset"
    },
    expansionPanelSummaryContent: {
      margin: 0,
      alignItems: "center"
    },
    expansionPanelDetails: _defineProperty({
      flexWrap: "wrap",
      textAlign: "left",
      padding: theme.spacing(1.5, 2)
    }, theme.breakpoints.down("sm"), {
      padding: theme.spacing(2, 2)
    }),
    expansionIcon: {
      color: theme.palette.green
    },
    summaryIcon: {
      width: theme.spacing(6),
      height: theme.spacing(6),
      marginRight: theme.spacing(1.5)
    },
    authorContainer: _defineProperty({
      marginTop: theme.spacing(1.5)
    }, theme.breakpoints.down("sm"), {
      marginTop: theme.spacing(2)
    }),
    avatarImg: {
      borderRadius: "50%",
      width: theme.spacing(4.5),
      height: theme.spacing(4.5),
      marginRight: theme.spacing(1)
    },
    authorName: {
      color: "rgba(0, 0, 0, 0.64)"
    },
    additionalInfo: {
      color: "rgba(0, 0, 0, 0.87)"
    },
    textUppercase: {
      textTransform: "uppercase"
    },
    fontJosefin: {
      fontFamily: "Josefin Sans, sans-serif;"
    },
    fontTen: {
      fontSize: "10px"
    }
  };
});
var FaqCore = function FaqCore(_ref) {
  var elements = _ref.elements;
  var classes = useStyles();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  useEffect(function () {
    if (elements) {
      setItems(elements);
    }
  }, [elements === null || elements === void 0 ? void 0 : elements.length]);
  var handleClick = function handleClick(index) {
    var newItemsArr = _toConsumableArray(items);
    newItemsArr[index].expand = !newItemsArr[index].expand;
    setItems(newItemsArr);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !items ? /*#__PURE__*/React__default.createElement(Skeleton, {
    variant: "rect",
    className: classes.expansionSkele,
    height: 400
  }) : items === null || items === void 0 ? void 0 : items.map(function (item, index) {
    var _item$author, _item$author2, _item$author3, _item$author4, _item$author5;
    return /*#__PURE__*/React__default.createElement(ExpansionPanel, {
      classes: {
        root: classes.expansionPanel
      },
      key: index
    }, /*#__PURE__*/React__default.createElement(ExpansionPanelSummary, {
      classes: {
        root: classes.expansionPanelSummary,
        content: classes.expansionPanelSummaryContent
      },
      onClick: function onClick() {
        return handleClick(index);
      },
      expandIcon: items[index].expand ? /*#__PURE__*/React__default.createElement(RemoveIcon, {
        className: classes.expansionIcon
      }) : /*#__PURE__*/React__default.createElement(AddIcon, {
        className: classes.expansionIcon
      }),
      "aria-controls": "panel".concat(index, "a-content"),
      id: "panel".concat(index, "a-header")
    }, (item === null || item === void 0 ? void 0 : item.iconUrl) && /*#__PURE__*/React__default.createElement("div", {
      className: classes.summaryIcon
    }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      src: retrieveContentfulImage(item === null || item === void 0 ? void 0 : item.iconUrl, {
        width: 48
      }),
      alt: "list-item-bullet"
    })), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h5",
      component: "h3"
    }, item === null || item === void 0 ? void 0 : item.question)), /*#__PURE__*/React__default.createElement(ExpansionPanelDetails, {
      className: classes.expansionPanelDetails
    }, (item === null || item === void 0 ? void 0 : item.answer) && /*#__PURE__*/React__default.createElement(CustomRichText, {
      document: item.answer
    }), (item === null || item === void 0 || (_item$author = item.author) === null || _item$author === void 0 ? void 0 : _item$author.names) && /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      alignItems: "center",
      className: classes.authorContainer
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true
    }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      className: classes.avatarImg,
      src: retrieveContentfulImage(item === null || item === void 0 || (_item$author2 = item.author) === null || _item$author2 === void 0 ? void 0 : _item$author2.imageUrl, {
        width: 108,
        height: 108
      }),
      alt: (item === null || item === void 0 || (_item$author3 = item.author) === null || _item$author3 === void 0 ? void 0 : _item$author3.imageTitle) || ""
    })), /*#__PURE__*/React__default.createElement(Grid, {
      item: true
    }, /*#__PURE__*/React__default.createElement(Typography, {
      className: clsx(classes.fontTen, classes.textUppercase, classes.fontJosefin, classes.authorName)
    }, item === null || item === void 0 || (_item$author4 = item.author) === null || _item$author4 === void 0 ? void 0 : _item$author4.names), /*#__PURE__*/React__default.createElement(Typography, {
      className: clsx(classes.fontTen, classes.textUppercase, classes.fontJosefin, classes.additionalInfo)
    }, item === null || item === void 0 || (_item$author5 = item.author) === null || _item$author5 === void 0 ? void 0 : _item$author5.additionalInfo)))));
  }));
};
FaqCore.propTypes = {
  elements: PropTypes__default.array
};

export { FaqCore as default };
//# sourceMappingURL=FaqCore.js.map
